import type { NavigationGuard, RouteLocation } from 'vue-router'

import { useApp } from '@/stores/app.stores'
import { useAuthStore } from '@/stores/auth.stores'

export const initializationGuard: NavigationGuard = async (to: RouteLocation) => {
  const authStore = useAuthStore()
  const appStore = useApp()

  await authStore.authenticate()

  if (!authStore.authorization) {
    return { name: 'logout' }
  }

  if (!appStore.isInitialized) {
    const route = await appStore.initialize(to)

    return route && route?.name !== to?.name ? route : true
  }

  return true
}
